import axios from '@/utils/axios';

// Types

// API

export default {
	async getCartDetails(payload: any[]): Promise<any> {

			return (await axios().patch(`/cart/`, payload)).data;
	},
};
